import React, { createContext, useContext, useState } from 'react';

const BrandContext = createContext();

const resolveBrand = (m) => {
  if (!m) return null;
  return m === 'bz' ? 'bz' : 'qikerp';
};

export const BrandProvider = ({ defaultBrand = 'qikerp', children }) => {
  const [brand, setBrand] = useState(() => {
    // On page load, try localStorage first (survives window.location.href redirects)
    const stored = localStorage.getItem('activeBrand');
    return stored || defaultBrand || 'qikerp';
  });

  const updateBrand = (m) => {
    const resolved = resolveBrand(m) || brand;
    localStorage.setItem('activeBrand', resolved);
    setBrand(resolved);
  };

  return (
    <BrandContext.Provider value={{ brand, updateBrand }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => {
  const context = useContext(BrandContext);
  if (!context) throw new Error('useBrand must be used inside BrandProvider');
  return context;
};